module.exports = __webpack_public_path__ + "img/logo_sib.76cce4fc.png";